import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type EmployeeModel from 'tio-data/models/employee';
import type PslfProfileModel from 'tio-data/models/pslf-profile';
import type SessionContextService from 'tio-employee/services/session-context';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';

export default class AuthenticatedAdminPslfSignRoute extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;

  async model() {
    const { currentEmployee } = this.sessionContext;

    const employee = await this.store.findRecord<EmployeeModel>(
      'employee',
      currentEmployee.id || '',
      {
        include: 'pslf-profile',
        reload: true,
      }
    );

    let profile = employee.pslfProfile;
    if (!profile) {
      profile = this.store.createRecord<PslfProfileModel>('pslf-profile', {
        employee,
      });
      await profile.save();
    }

    return employee;
  }
}
